module.exports = __webpack_public_path__ + "static/f2-aee29023af96bc3c5387f2f083fcdb5b.jpeg";